export function buildStudentDriverInvitePayload({ student, parent, form }) {
  return {
    school_id: Number(student.school_id),
    authorizing_contact_id: Number(parent.id),
    student_ids: [Number(student.id)],
    start_date: form.startDate,
    end_date: form.endDate,
    driver_f_name: String(form.fName || '').trim(),
    driver_l_name: String(form.lName || '').trim(),
    driver_phone: String(form.phone || '').trim(),
    driver_email: String(form.email || '').trim().toLowerCase(),
  };
}

export function validateStudentDriverInviteForm(form) {
  if (!String(form?.fName || '').trim() || !String(form?.lName || '').trim()) {
    return 'Enter the driver’s first and last name.';
  }
  if (!String(form?.phone || '').trim() && !String(form?.email || '').trim()) {
    return 'Enter the driver’s phone number or email address.';
  }
  if (!form?.startDate || !form?.endDate) return 'Choose the authorization dates.';
  if (form.endDate < form.startDate) return 'End date cannot be before start date.';
  return '';
}
